import React from 'react';

export default function Button({
  className,
  children,
  type = 'button',
  onClick,
}) {
  return (
    <button type={type} className={className} onClick={onClick}>
      {children}
    </button>
  );
}
